import React from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import  { history } from '../../store/configureStore';

import { 
    getFilteredDataForCatalog, 
    getCatalogImgSrc, 
    getFromattedPreset 
} from '../../selectors/entities/filters';
import { getSelectedFabricValues } from '../../selectors/entities/general';
import { getActivePreset } from '../../selectors/entities/ui';

import { onFabricChanged } from "../../actions/render";
import { applyPreset } from '../../actions/ui';
import ProductLazyCanvas from '../ProductLazyCanvas';

class RenderRecommended extends React.Component {
    constructor() {
        super();
        this.state = {
            recommendedPage: 0,
            startIndex: null,
            fabricEnumsLocal: [],
            initialClientX: 0,
            finalClientX: 0,
        }
    }

    componentDidMount() {
        const { selectedFabric, activePreset, fabricEnums } = this.props;

        const preset = getFromattedPreset(activePreset.displayName.toLowerCase())
        const farbricPreset = getCatalogImgSrc(selectedFabric.article.toLowerCase(), preset)

        let fabricIndex = 0;
        let fabricEnumsCopy = fabricEnums.filter((item, i) => {
            if(item.catalog.imgSrc === farbricPreset){
                fabricIndex = i;
            }
            return item.catalog.imgSrc !== farbricPreset
        });

        this.setState({
            startIndex: fabricIndex < 0 ? 0 : fabricIndex > fabricEnumsCopy.length - 1 ? 
                        fabricEnumsCopy.length - 1 : fabricIndex,
            fabricEnumsLocal: fabricEnumsCopy,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedFabric, activePreset, fabricEnums } = this.props;

        const preset = getFromattedPreset(activePreset.displayName.toLowerCase())
        const farbricPreset = getCatalogImgSrc(selectedFabric.article.toLowerCase(), preset)

        if(prevProps.selectedFabric.article !== selectedFabric.article || prevProps.activePreset.id !== activePreset.id) {
            let fabricIndex = 0;
            let fabricEnumsCopy = fabricEnums.filter((item, i) => {
                if(item.catalog.imgSrc === farbricPreset){
                    fabricIndex = i;
                }
                return item.catalog.imgSrc !== farbricPreset
            });

            this.setState({
                startIndex: fabricIndex < 0 ? 0 : fabricIndex > fabricEnumsCopy.length - 1 ? 
                            fabricEnumsCopy.length - 1 : fabricIndex,
                fabricEnumsLocal: fabricEnumsCopy,
            });
        }
    }

    onSelectProduct = (val, i, preset) => {
        history.push({
            pathname: window.location.pathname,
            search: `?` + new URLSearchParams({
                    fabric: val, 
                    preset: preset
                }).toString(),
        })
    }

    getIndeсes = (indexForPaging) => {
        const { fabricEnumsLocal } = this.state;
        const enumsLength = fabricEnumsLocal.length;

        if(this.props.isMobile)
            return [
                indexForPaging - 1 < 0 ? (enumsLength - 1) : indexForPaging - 1,
                indexForPaging,
            ];

        return [
            indexForPaging - 2 < 0 ? enumsLength + (indexForPaging - 2) : indexForPaging - 2,
            indexForPaging - 1 < 0 ? enumsLength - 1 : indexForPaging - 1,
            indexForPaging,
            indexForPaging + 1 > (enumsLength - 1) ? 0 : indexForPaging + 1,
        ]
    }

    renderList = () =>  {
        const { startIndex, fabricEnumsLocal } = this.state;

        if(fabricEnumsLocal.length === 0)
            return null;

        if(startIndex === undefined) return null;

        const indeсes = [...new Set(this.getIndeсes(startIndex))];

        return indeсes.map((productIndex, i) => {
            if(fabricEnumsLocal[productIndex]) {
                const product = fabricEnumsLocal[productIndex];
                return (
                    <ProductLazyCanvas 
                        key={product.article + i}
                        index={productIndex}
                        product={product}
                        onChange={this.onSelectProduct}
                        displayName={product.displayName}
                        value={product.article}
                        price={product.price}
                        isNew={product.isNew}
                        isSale={product.isSale}
                        preset={product.catalog.preset} />
                )
            }
        })
    }

    recommendedBrowsing = (route) => {
        const { startIndex, fabricEnumsLocal } = this.state;

        const enumsLength = fabricEnumsLocal.length;
        let index = startIndex;
        if(route === 'next') {
            index = startIndex + 1 > (enumsLength - 1) ? 0 : startIndex + 1;
        }
        if(route === 'prev') {
            index = startIndex - 1 < 0 ? enumsLength - 1 : startIndex - 1;
        }

        this.setState({
            startIndex: index,
        })
    }

    handleTouchStart = (e) => {
        this.setState({
            initialClientX: e.nativeEvent.touches[0].clientX,
            finalClientX: e.nativeEvent.touches[0].clientX,
        })
    }
    
    handleTouchMove = (e) => {
        this.setState({
            finalClientX: e.nativeEvent.touches[0].clientX,
        })
    }

    handleTouchEnd = () => {
        const { initialClientX, finalClientX } = this.state;
        if (finalClientX < initialClientX) {
            this.recommendedBrowsing('next');
        }
        if (finalClientX > initialClientX) {
            this.recommendedBrowsing('prev');
        }

        this.setState({
            initialClientX: 0,
            finalClientX: 0,
        })
    }

    render() {
        return (
            <div className='b-rit-product-page__recommends-wrapper'>
                <p className='b-rit-product-page__subtitle'>Рекомендуем</p>
                <div className='b-rit-product-page__recommends-carousel'>
                    <button 
                        className="b-rit-product-page__recommends-carousel--prev"
                        onClick={()=>{this.recommendedBrowsing('prev')}}
                        ></button>
                    <div className="b-rit-product-page__recommends-list">
                        <div className='b-rit-product-list'
                            onTouchStart={this.handleTouchStart}
                            onTouchMove={this.handleTouchMove}
                            onTouchEnd={this.handleTouchEnd}
                        >
                            {this.renderList()}
                        </div>
                    </div>
                    <button 
                        className="b-rit-product-page__recommends-carousel--next"
                        onClick={()=>{this.recommendedBrowsing('next')}}
                        ></button>
                </div>
            </div>

        )
    }
}

RenderRecommended.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    selectedFabric: PropTypes.object.isRequired,
    activePreset: PropTypes.object.isRequired,
    fabricEnums: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
}

function mapStateToProps(state, ownProps) {
    return {
        fabricEnums: getFilteredDataForCatalog(state),
        selectedFabric: getSelectedFabricValues(state),
        activePreset: getActivePreset(state),

        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            onFabricChanged,
            applyPreset,
        }, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(RenderRecommended));